import React from 'react';
import { Container } from '@mui/material';
import ProgressNoteTemplateCreator from '../components/ProgressNoteTemplateCreator';

const ProgressNoteTemplateCreatorPage = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <ProgressNoteTemplateCreator />
    </Container>
  );
};

export default ProgressNoteTemplateCreatorPage;